<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter02">
<a id="page2">
</a><div class="chapterHead"><a id="page2">
</a><h2 class="chapterTitle"><a id="page2"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_02"><span class="bold">WHAT I LEARN FROM <em class="italic">COSMO</em> WHILE WAITING TO SEE THE DOCTOR</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I learn that pumpkin pie</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and lavender</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">are aphrodisiacs.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I learn that the French term for crabs</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">is <em class="italic">papillons d’amour—</em></p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">butterflies of love.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I learn that the average</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">speed of ejaculation</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">is twenty-eight miles per hour.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">And I’m just about</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">to learn the identity</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">of “the next awesome sex prop”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">(which</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the magazine says</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">is probably in my <em class="italic">purse!)</em></p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">when,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">much to my chagrin,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the nurse calls me in.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-chapter02.vue?5b3f3842